<template>
  <div style="display:grid; min-height:100vh;">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      background-color="#6b6969"
    />
    <green-nav />
    <div class="row" style="margin-top: 5.4rem">
      <div class="col-md-5 backImage d-none d-sm-block"></div>
      <div class="col-md-7">
        <div class="container">
          <h2 class="text-green font-weight-bold mt-md-5">
            Membership Application
          </h2>
          <p class="mb-4">
            Fill out the application form to apply to become part of our program
          </p>
          <form class="" @submit.prevent="submitForm">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">
                    Full Name of Applicant
                  </label>
                  <input
                    id="name"
                    required
                    v-model="data.full_name"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="email_address">
                    Email Address
                  </label>
                  <input
                    id="email_address"
                    type="email"
                    required
                    v-model="data.email"
                    class="form-control"
                  />
                </div>

                <div class="form-group">
                  <label for="region">
                    Region
                  </label>
                  <select
                    class="form-control"
                    id="region"
                    required
                    v-model="data.region"
                  >
                    <option value="">-- Select region --</option>
                    <option
                      v-for="(reg, i) in regions"
                      :key="i"
                      :value="reg.region"
                      >{{ reg.region }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label for="hub_name">
                    Name of Hub
                  </label>
                  <select
                    class="form-control"
                    id="hub_name"
                    required
                    v-model="data.hub_id"
                  >
                    <option value="">-- Select hub --</option>
                    <option
                      v-for="(reg, i) in hubs"
                      :key="i"
                      :value="reg['partner_id']"
                      >{{ reg["name"] }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="phone_number">
                    Phone Number
                  </label>
                  <input
                    id="phone_number"
                    required
                    v-model="data.phone_number"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="age">
                    Age of Applicant
                  </label>
                  <input
                    id="age"
                    type="date"
                    required
                    v-model="data.applicant_dob"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="autocomplete">
                    City
                  </label>
                  <input
                    id="autocomplete"
                    required
                    v-model="data.city"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="program">
                    Which of GTL's training programs have you been a part of?
                  </label>
                  <select class="form-control" id="program" v-model="programs">
                    <option
                      v-for="(reg, i) in gtl_programs"
                      :key="i"
                      :value="reg"
                      >{{ reg }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="why_join">
                    Briefly describe why you want to be part of Ladies in Tech
                  </label>
                  <textarea
                    id="why_join"
                    required
                    v-model="data.why_join"
                    style="resize: vertical"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>
                    Are you willing to commit to the community and participate
                    in all community activities?
                  </label>
                  <div
                    style="display: flex; flex-direction: row; justify-content: space-between"
                    class="col-md-7 col-12"
                  >
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="yes"
                          value="Yes"
                          v-model="data.willing_to_commit"
                        />
                        Yes
                        <span class="circle">
                          <span class="check" />
                        </span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="no"
                          value="No"
                          v-model="data.willing_to_commit"
                        />
                        No
                        <span class="circle">
                          <span class="check" />
                        </span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="maybe"
                          value="Maybe"
                          v-model="data.willing_to_commit"
                        />
                        Maybe
                        <span class="circle">
                          <span class="check" />
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 text-right mt-4">
                <button type="submit" class="btn btn-orange pl-5 pr-5">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import Swal from "sweetalert2";
import GreenNav from "../components/navbar_green";
import downFooter from "../components/footer";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      data: {
        full_name: "",
        email: "",
        phone_number: "",
        applicant_dob: "",
        region: "",
        city: "",
        hub_id: "",
        programs_attended: [],
        why_join: "",
        willing_to_commit: "Yes"
      },
      programs: "",
      regions: [],
      hubs: [],
      gtl_programs: ["National Digital Media Program"],
      height: 128,
      width: 128,
      autocomplete: null
    };
  },
  components: {
    Loading,
    downFooter,
    GreenNav
  },

  methods: {
    submitForm() {
      this.isLoading = true;
      if (this.programs) {
        this.data.programs_attended.push(this.programs);
      }
      axios
        .post(
          "https://ladies-in-tech-webservice.azurewebsites.net/create-membership",
          this.data
        )
        .then(res => {
          Swal.fire({
            title: "Success!",
            text: "Membership application has been completed successfully...",
            icon: "success",
            confirmButtonText: "ok"
          }).then(result => {
            if (result) {
              this.$router.push("/");
            }
          });
        })
        .catch(err => {
          Swal.fire({
            title: "Error!",
            text: err.response["data"]["message"],
            icon: "error",
            confirmButtonText: "ok"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    executeMap() {
      this.autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete"),
        {
          componentRestrictions: {
            country: "gh"
          },
          fields: [
            "address_components",
            "geometry",
            "icon",
            "name",
            "formatted_address"
          ]
        }
      );
      this.autocomplete.addListener("place_changed", this.onPlaceChanged);
    },
    onPlaceChanged() {
      let place = this.autocomplete.getPlace();
      this.data.city = place.name +' ('+place.formatted_address+')';
      // this.data.location = place.formatted_address;
    },
    getRegions() {
      this.isLoading = true;
      axios
        .get(
          "https://kc0dn3da9f.execute-api.us-east-1.amazonaws.com/dev/regions"
        )
        .then(res => {
          this.regions = res.data;
        })
        .catch(err => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    getPartnerHubs() {
      this.isLoading = true;
      axios
        .get(
          "https://ladies-in-tech-webservice.azurewebsites.net/get-partner-hubs"
        )
        .then(res => {
          this.hubs = res.data.data;
        })
        .catch(err => {})
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  mounted: function() {
    this.getRegions();
    this.getPartnerHubs();
    this.$loadScript(
      "https://maps.googleapis.com/maps/api/js?key=" +
        process.env.VUE_APP_GOOGLE_MAPS_KEY +
        "&libraries=places"
    )
      .then(() => {
        this.executeMap();
      })
      .catch(() => {
        // Failed to fetch script
      });
  }
};
</script>

<style scoped>
.backImage {
  background: url("../../public/assets/img/membership-application.png")
    no-repeat center;
  background-size: cover;
  background-position-y: center;
}
label {
  color: #444;
}

.form-control {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.375rem 0.75rem;
  margin-top: 0.5rem !important;
}
textarea {
  min-height: 7rem;
}

.form-control:invalid {
  background-image: none !important;
}
</style>
